import React from 'react'
import BaseField from './BaseField'

const TextareaField = props => {
	const { input, type, rows, className, placeholder } = props

	return <BaseField {...props}>
		<textarea
			type={type}
			rows={rows}
			className={`c-textarea ${className}`}
			{...input}
			id={input.name}
			placeholder={placeholder}></textarea>
	</BaseField>
}

export default TextareaField



// WEBPACK FOOTER //
// ./src/components/form/TextareaField.js